// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Header from '../header/Header'
import { i18n } from '../index'
import css from './taskList.css'
import TaskListActive from './TaskListActive'
import TaskListArchive from './TaskListArchive'
type Props = {
  history: any
  location: any
}
const TABS = [
  {
    label: 'Aktiiviset',
    value: 'aktiiviset',
  },
  {
    label: 'Arkisto',
    value: 'arkisto',
  },
]
const BASE_PATH = '/tehtavalista'

class TaskList extends React.Component<Props> {
  onTabClick = (tab) => {
    const { history } = this.props
    history.push(`${BASE_PATH}/${tab.value}`)
  }
  getActiveTab = () => {
    const { location } = this.props
    const parts = location.pathname.split('/')

    if (parts.length === 3) {
      return parts[2]
    }

    return 'aktiiviset'
  }

  render() {
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('taskList.header')}
          tabs={TABS}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('taskList.header')}</Typography>
          <Switch>
            <Route exact path='/tehtavalista/arkisto' component={TaskListArchive} />
            <Route path='/tehtavalista/aktiiviset' component={TaskListActive} />
            <Route exact path='/tehtavalista' component={TaskListActive} />
            <Redirect from='/tehtavalista/' to='/tehtavalista' />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(TaskList)
